// extracted by mini-css-extract-plugin
export default {"melodyVideo":"wN-z","isFullWidth":"xN-z","landingPageVideo":"yN-z","play":"zN-z","iframeVideo":"AN-z","playHidden":"BN-z","fullwidth":"CN-z"};